import { registerGroup, registerPath } from '@visactor/vrender-kits';

export function loadLinkPathComponent() {
  registerGroup();
  registerPath();
}
